import { useDispatch } from "react-redux";
import { showModal } from "../../../../../../../store/modalSlice";
import { MODAL_ID } from "../../../../../../../utils/constants";

/**
 * @desc Handler for deleting a convention.
 */
export const useHandlers = () => {
  const dispatch = useDispatch();

  // HANDLERS -----------------------------------------------------------------

  /**
   * @desc Show delete convention modal on click.
   */
  const handleClick = () => {
    dispatch(
      showModal({
        id: MODAL_ID.DELETE_CONVENTION,
      })
    );
  };

  // HOOK ---------------------------------------------------------------------

  return { handleClick };
};
